module.exports = __webpack_public_path__ + "img/comments-dollar.7691a545.svg";